import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError } from "rxjs/operators";
import { Observable, throwError } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class TramitePensionServiceInvalidez {

  urlBase = environment.BASE_BACKEND + '/tramite-pension';
  tipoTramite = 'IN';
  private readonly STORAGE_KEY = 'tipoErrorInvalidez';

  constructor(private readonly http: HttpClient) { }

  public obtenerValidacionesTramitePensionInvalidez() {
    const url = `${environment.BASE_BACKEND}/tramite-pension/invalidez/validaciones`;
    return this.http.post(url, { tipoTramite: this.tipoTramite }).pipe(
      catchError(this.handleError.bind(this))
    );
  }

  private handleError(error: any): Observable<never> {
    // El home (u otro caller) decide la pantalla; aquí solo propagamos el fallo.
    return throwError(() => error);
  }

  setError(error: any) {
    sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(error));
  }

  getError(): any {
    const data = sessionStorage.getItem(this.STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  }

  clearError() {
    sessionStorage.removeItem(this.STORAGE_KEY);
  }
}
